// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2x2Ub","container":"styles_container__3TbwV","leftBar":"styles_leftBar__2yTaR"};